module.exports = __webpack_public_path__ + "media/src/fonts/PTRoubleSans-a943a25e48000cc596c220b93541addb.woff";